import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";

import { SimpleNotificationType } from "../../components/SimpleNotification";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function QuickbooksCallbackViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: SimpleNotificationType.Success,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const onStartCallback = async function (params) {
    // params can be an object like { code, state, realmId }
    setLoading(true);
    let callResult;

    callResult = await makePostApiCall(`quickbooks/callback`, params);
    setLoading(false);
    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        message: "Quickbooks connected successfully",
        title: "Quickbooks connected successfully, you may close this window",
        type: SimpleNotificationType.Success,
      });

      return true;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(
        "Could not Finish Quickbooks Connection",
        callResult.message,
      );
      return false;
    }
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    onStartCallback,
    showSimpleNotification,
    setShowSimpleNotification,
  };
}
